import axios from "axios";

export const fetchGlobalLeaderBoards = async (gameVariant, timeVariant, pageNo) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/leaderboard?gameVariant=${gameVariant}&timeVariant=${timeVariant}&pageNo=${pageNo}`)

    return await response.data
}

export const fetchClubLeaderBoards = async (gameVariant, timeVariant, pageNo, clubId, isClubElo) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/leaderboard/club?gameVariant=${gameVariant}&timeVariant=${timeVariant}&pageNo=${pageNo}&clubId=${clubId}&isClubElo=${isClubElo}`)

    return await response.data
}